import React from "react";
import { BrowserRouter, Navigate, Routes, Route, useLocation } from "react-router-dom";
import { ModeProvider } from "./context/ModeContext";
import { AuthProvider } from "./context/AuthContext";
import AppShell from "./components/AppShell";
import Landing from "./pages/Landing";
import Drivers from "./pages/Drivers";
import DriverProfile from "./pages/DriverProfile";
import Teams from "./pages/Teams";
import TeamProfile from "./pages/TeamProfile";
import Calendar from "./pages/Calendar";
import News from "./pages/News";
import Standings from "./pages/Standings";
import Learn from "./pages/Learn";
import AuthPage from "./pages/AuthPage";
import AuthCallback from "./pages/AuthCallback";
import { AdminRoutes } from "./admin/AdminRoutes";
import RaceWorkspace from "./race/RaceWorkspace";
import { getDashboardReplayRedirect } from "./lib/replayRoutes";

export function DashboardRouteGate() {
    const location = useLocation();
    const redirectTo = getDashboardReplayRedirect(location.pathname, location.search);
    if (redirectTo) return <Navigate to={redirectTo} replace />;
    return <Navigate to="/race/live" replace />;
}

function App() {
    return (
        <ModeProvider>
            <AuthProvider>
                <BrowserRouter>
                    <>
                        <Routes>
                            <Route path="/demo" element={<Navigate to="/race/live" replace />} />
                            <Route path="/dashboard" element={<DashboardRouteGate />} />
                            <Route element={<AppShell />}>
                                <Route path="/" element={<Landing />} />
                                <Route path="/live-dashboard" element={<RaceWorkspace mode="live" />} />
                                <Route path="/race" element={<RaceWorkspace />} />
                                <Route path="/race/live" element={<RaceWorkspace mode="live" />} />
                                <Route path="/race/:sessionKey" element={<RaceWorkspace />} />
                                <Route path="/replay" element={<RaceWorkspace />} />
                                <Route path="/replay/:sessionKey" element={<RaceWorkspace />} />
                                <Route path="/drivers" element={<Drivers />} />
                                <Route path="/drivers/" element={<Drivers />} />
                                <Route path="/drivers/:id" element={<DriverProfile />} />
                                <Route path="/teams" element={<Teams />} />
                                <Route path="/teams/:id" element={<TeamProfile />} />
                                <Route path="/calendar" element={<Calendar />} />
                                <Route path="/news" element={<News />} />
                                <Route path="/standings" element={<Standings />} />
                                <Route path="/learn" element={<Learn />} />
                                <Route path="/learn/:topicId" element={<Learn />} />
                                <Route path="/login" element={<AuthPage mode="login" />} />
                                <Route path="/signup" element={<AuthPage mode="signup" />} />
                                <Route path="/auth/callback" element={<AuthCallback />} />
                            </Route>
                        </Routes>
                        <AdminRoutes />
                    </>
                </BrowserRouter>
            </AuthProvider>
        </ModeProvider>
    );
}

export default App;
